import { State, Action, Selector, StateContext } from '@ngxs/store';
import { SetDefaultDesktopInput, SetDefaultInput } from 'app/shared/settings/settings.actions';

export interface InputDevice {
  name: string;
  id: string;
  isDesktop?: boolean;
}

export interface SettingsStateModel {
  defaultInput: InputDevice;
  defaultDesktopInput: InputDevice;
  streamingPageMode: 'titled' | 'fullscreen';
}

@State<SettingsStateModel>({
  name: 'settings',
  defaults: {
    streamingPageMode: 'fullscreen',
    defaultInput: {
      name: null,
      id: null,
      isDesktop: false
    },
    defaultDesktopInput: {
      name: null,
      id: null,
      isDesktop: false
    },
  }
})
export class SettingsState {
  @Selector()
  public static getState(state: SettingsStateModel) {
    return state;
  }

  @Selector()
  public static defaultInput(state: SettingsStateModel) {
    return state.defaultInput;
  }

  @Selector()
  public static defaultDesktopInput(state: SettingsStateModel) {
    return state.defaultDesktopInput;
  }
  @Selector()
  public static streamingPageMode(state: SettingsStateModel) {
    return state.defaultDesktopInput;
  }

  @Action(SetDefaultInput)
  public setDefaultInput(
    ctx: StateContext<SettingsStateModel>,
    { inputDevice, ...rest }: SetDefaultInput
  ) {
    console.log(inputDevice);
    console.log(rest);
    const stateModel = ctx.getState();
    const newState = {
      ...stateModel,
      defaultInput: { ...stateModel.defaultInput, ...inputDevice },
    };
    ctx.setState(newState);
  }

  @Action(SetDefaultDesktopInput)
  public setDefaultDesktopInput(
    ctx: StateContext<SettingsStateModel>,
    { inputDevice }: SetDefaultDesktopInput
  ) {
    const stateModel = ctx.getState();
    const newState = {
      ...stateModel,
      defaultDesktopInput: { ...stateModel.defaultDesktopInput, ...inputDevice },
    };
    ctx.setState(newState);
  }
}
